import { TResponsive, TAlign } from './types'

export const BREAKPOINTS: { [T in TResponsive]: number } = {
    xs: 0,
    sm: 769,
    md: 1025,
    lg: 1301,
    xl: 1441,
    vnw: 1141
}

export const CONTAINER: { [T in TResponsive | 'full']: number | string } = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1300,
    xl: 1440,
    vnw: 1140,
    full: '100%'
}

export const MAXIMUM_COL = 24

export const alignValues: { [T in TAlign]: string } = {
    top: 'start',
    middle: 'center',
    bottom: 'end'
}
